import { useEffect, useState } from 'react'

import { getLocalStorageItem } from '@shared/utils'
import { getFiltersObject } from '@shared/ui'

import { CarouselDots } from '../carousel-dots'
import { Carousel } from '../carousel/carousel'
import { Schedule } from '../schedule'

export const CarouselAgenda = ({
  policyId,
  noDigital,
  schedules,
  setFilters,
  dateSelected,
  fieldName,
  isMod,
  modifyDate,
  setModifyDate,
  isSr,
}) => {
  const noDigitalLocal = getLocalStorageItem('no_digital')

  useEffect(() => {
    if (noDigitalLocal !== undefined && noDigitalLocal !== null) {
      if (noDigitalLocal === false) {
        setFilters({})
      } else {
        setFilters(getFiltersObject({ noDigital, isSr }))
      }
    }
  }, [noDigitalLocal, setFilters])

  const groupSchedules = () => {
    if (!noDigitalLocal && !noDigital) {
      // Group by complete weeks (7 days) instead of arbitrary number for online appointments
      const groupedByWeeks = []
      
      // First, group schedules by date
      const schedulesByDate = schedules.reduce((acc, schedule) => {
        const date = new Date(schedule.slotDate).toISOString().split('T')[0]
        if (!acc[date]) {
          acc[date] = []
        }
        acc[date].push(schedule)
        return acc
      }, {})
      
      // Get sorted dates
      const sortedDates = Object.keys(schedulesByDate).sort()
      
      // Group dates into weeks (7 consecutive days)
      for (let i = 0; i < sortedDates.length; i += 7) {
        const weekDates = sortedDates.slice(i, i + 7)
        const weekSchedules = weekDates.flatMap(date => schedulesByDate[date])
        if (weekSchedules.length > 0) {
          groupedByWeeks.push(weekSchedules)
        }
      }
      
      return groupedByWeeks
    } else {
      const groupedBySlots = []
      let slot = []
      for (let i = 0; i < schedules.length; i++) {
        slot.push(schedules[i])
        if (slot.length === 14) {
          groupedBySlots.push(slot)
          slot = []
        }
      }
      if (slot.length > 0) {
        groupedBySlots.push(slot)
      }

      return groupedBySlots
    }
  }
  const groupedSchedules = groupSchedules()

  // Debug log para verificar la agrupación (shared component) - Commented out to reduce console noise
  // console.log('🗓️ Shared CarouselAgenda grouping:', {
  //   totalSchedules: schedules.length,
  //   groupedSchedulesCount: groupedSchedules.length,
  //   groupSizes: groupedSchedules.map(group => group.length),
  //   firstGroupSample: groupedSchedules[0]?.slice(0, 3).map(s => s.slotDate),
  //   noDigital: noDigital,
  //   noDigitalLocal: noDigitalLocal,
  //   isOnlineAppointment: !noDigitalLocal && !noDigital
  // })

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [date, setDate] = useState(null)

  useEffect(() => {
    const newDate = isMod ? modifyDate : dateSelected
    setDate(newDate)
  }, [isMod, modifyDate, dateSelected])

  return (
    <Carousel DotsComponent={CarouselDots}>
      {groupedSchedules.map((group, index) => (
        <Schedule
          key={index}
          noDigital={noDigital}
          schedules={group}
          fieldName={fieldName}
          isMod={isMod}
          modifyDate={modifyDate}
          setModifyDate={setModifyDate}
        />
      ))}
    </Carousel>
  )
}
